import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const TonsCarbono = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getCarbonFootprint, dataReady } = useData();

  // Get data from Excel (2025 - TON CO2)
  const excelData = dataReady ? getCarbonFootprint() : { labels: [], values: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Alimentos', 'Automotriz', 'Construcción', 'Manufactura', 'Retail', 'Servicios Logísticos'];

  const data2025 = excelData.values.length > 0 ? excelData.values : [188047, 105871, 156864, 224062, 172553, 149206];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues = labels.map(label => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? data2025[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2025',
        data: dataValues,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  // Calculate max for scale, with extra headroom so the top data labels
  // don't collide with the legend above the chart
  const maxValue = Math.max(...data2025);
  const scaleMax = Math.ceil((maxValue * 1.15) / 500) * 500;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 40,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw.toLocaleString('en-US')} TON CO2`,
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        offset: 5,
        formatter: (value) => value.toLocaleString('en-US'),
        font: { weight: 'bold', size: 14 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Ton CO2',
        },
        beginAtZero: true,
        max: scaleMax,
      },
    },
  };

  const infoContent = {
    formula: 'Huella de carbono 2025 (ton CO2) = Suma de huella de carbono por industria',
    description: 'Muestra la cantidad de emisiones de gases de efecto invernadero que se emiten a la atmósfera por medio de alguna actividad humana, que puede ser un producto o un servicio.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TonsCarbono;
